import { useExperience } from '@ninetailed/experience.js-next';
import { INavigationElement } from 'global';
import { NavigationType, PetType, TargetGroup } from '../utils';

type NavigationElementType = keyof typeof NavigationType;
type PetTypeKey = keyof typeof PetType;
type TargetGroupKey = keyof typeof TargetGroup;

export interface NavigationElementConfig {
  type: NavigationElementType;
  petType: PetTypeKey;
  targetGroup: TargetGroupKey;
  name: string;
}

export interface NavigationExperiments {
  [key: string]: {
    element: INavigationElement | null;
    experiment: ReturnType<typeof useExperience>;
  };
}

export const NAVIGATION_ELEMENT_CONFIGS: NavigationElementConfig[] = [
  {
    type: 'DESKTOP',
    petType: 'DOG',
    targetGroup: 'NEW_CUSTOMER',
    name: 'Desktop Dog New Customer',
  },
  {
    type: 'DESKTOP',
    petType: 'DOG',
    targetGroup: 'EXISTING_CUSTOMER',
    name: 'Desktop Dog Existing Customer',
  },
  {
    type: 'DESKTOP',
    petType: 'CAT',
    targetGroup: 'NEW_CUSTOMER',
    name: 'Desktop Cat New Customer',
  },
  {
    type: 'DESKTOP',
    petType: 'CAT',
    targetGroup: 'EXISTING_CUSTOMER',
    name: 'Desktop Cat Existing Customer',
  },
  {
    type: 'MOBILE',
    petType: 'DOG',
    targetGroup: 'NEW_CUSTOMER',
    name: 'Mobile Dog New Customer',
  },
  {
    type: 'MOBILE',
    petType: 'DOG',
    targetGroup: 'EXISTING_CUSTOMER',
    name: 'Mobile Dog Existing Customer',
  },
  {
    type: 'MOBILE',
    petType: 'CAT',
    targetGroup: 'NEW_CUSTOMER',
    name: 'Mobile Cat New Customer',
  },
  {
    type: 'MOBILE',
    petType: 'CAT',
    targetGroup: 'EXISTING_CUSTOMER',
    name: 'Mobile Cat Existing Customer',
  },
];
